
import React, { useEffect, useState } from "react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) setVisible(true);
  }, []);

  const handleChoice = (value) => {
    localStorage.setItem("cookieConsent", value);
    setVisible(false);
  };

  const web = (e) => {
    e.preventDefault();

    const fileName = "/תקנון-שימוש-באתר - אוחנה -MMA.pdf";

    window.open(
      encodeURI(fileName),
      "_blank",
      "noopener,noreferrer"
    );
  };

  if (!visible) return null;

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.textBox}>
          <strong style={styles.title}>
            שימוש בעוגיות (Cookies)
          </strong>

          <span style={styles.text}>
            אתר זה עושה שימוש בקובצי Cookies וטכנולוגיות מעקב דומות
            לצורך הפעלה תקינה, שיפור ביצועים, ניתוח שימושים והתאמת
            חוויית המשתמש. אנו עשויים לאסוף מידע אנונימי סטטיסטי
            לשם שיפור השירותים. המשך השימוש באתר מהווה הסכמה לכך.
          </span>

          <a
            href="/privacy-policy"
            style={styles.link}
            onClick={web}
          >
            למדיניות הפרטיות
          </a>
        </div>

        <div style={styles.actions}>
          <button
            onClick={() => handleChoice("accepted")}
            style={{ ...styles.button, ...styles.accept }}
          >
            אישור
          </button>

          <button
            onClick={() => handleChoice("declined")}
            style={{ ...styles.button, ...styles.decline }}
          >
            סירוב
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    width: "100%",
    zIndex: 2147483647,
    display: "flex",
    justifyContent: "center",
    padding: 0,
    margin: 0,
    boxSizing: "border-box",
    overflow: "hidden",
  },

  card: {
    width: "100%",
    maxWidth: "100%",
    background: "#3d0000",
    color: "#fff",
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
    padding: "10px 20px",
    boxShadow: "0 -5px 25px rgba(0,0,0,0.3)",
    direction: "rtl",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    textAlign: "right",
    gap: "8px",
    boxSizing: "border-box",
  },

  textBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "8px",
    flex: 1,
    minWidth: 0,
  },

  title: {
    fontSize: "15px",
    fontWeight: "700",
    whiteSpace: "nowrap",
  },

  text: {
    fontSize: "13px",
    color: "#d1d5db",
    lineHeight: "1.5",
  },

  link: {
    color: "#60a5fa",
    fontWeight: "700",
    fontSize: "13px",
    textDecoration: "none",
    whiteSpace: "nowrap",
  },

  actions: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    flexShrink: 0,
  },

  button: {
    border: "none",
    borderRadius: "9px",
    padding: "10px 22px",
    fontSize: "14px",
    fontWeight: "700",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },

  accept: {
    background: "linear-gradient(135deg,#3b82f6,#2563eb)",
    color: "#fff",
  },

  decline: {
    background: "rgba(255,255,255,0.08)",
    color: "#fff",
    border: "1px solid rgba(255,255,255,0.2)",
  },
};
